'use client';

import { useCallback, useEffect, useState } from 'react';

export const useMediaQuery = (query: string, target?: boolean) => {
  const [targetReached, setTargetReached] = useState<boolean>(target ?? false);

  const updateTarget = useCallback((e: { matches: any }) => {
    if (e.matches) setTargetReached(true);
    else setTargetReached(false);
  }, []);

  useEffect(() => {
    const media = window.matchMedia(query);
    media.addEventListener('change', updateTarget);

    if (media.matches) setTargetReached(true);

    return () => media.removeEventListener('change', updateTarget);
  }, []);

  return targetReached;
};

export const useMobileSMMediaQuery = () => useMediaQuery('(min-width: 280px)');
export const useMobileMDMediaQuery = () => useMediaQuery('(min-width: 320px)');
export const useMobileLGMediaQuery = () => useMediaQuery('(min-width: 375px)');
export const useTabletMediaQuery = () => useMediaQuery('(min-width: 425px)');
export const useMobileMiniMediaQuery = () => useMediaQuery('(max-width: 360px)');
export const useXSMediaQuery = () => useMediaQuery('(max-width: 576px)');
export const useSMMediaQuery = () => useMediaQuery('(min-width: 576px)');
export const useMDMediaQuery = () => useMediaQuery('(min-width: 768px)');
export const useLGMediaQuery = () => useMediaQuery('(min-width: 650px)');
export const useXLMediaQuery = () => useMediaQuery('(min-width: 1200px)');
export const useXXLMediaQuery = () => useMediaQuery('(min-width: 1600px)');
